import {useLocation, useNavigate, useSearchParams} from 'react-router-dom'
import {useIntl} from 'react-intl'
// import Tabs, {Tab} from 'react-best-tabs'
import 'react-best-tabs/dist/index.css'
import {Company} from '../../profile/components/Company'
// import { Team } from '../../profile/components/Team'
// import TeamUpdated from '../../profile/components/TeamUpdated'
import {EmailIntegration} from '../../profile/components/EmailIntegration'
import {TransactionalEmailIntegration} from '../../profile/components/TransactionalEmailIntegration'
import {BCCTracking} from '../../profile/components/BCCTracking'
// import LockIcon from '../../../../media/Generic/ic-lock-black.svg'

import {
  companyInitialValues,
  postmarkInitialValues,
  initialValues,
  customSmtpInitialValues,
  senderInitialValues,
  nylasGoogleInitialValues,
  nylasMicrosoftInitialValues,
} from '../../profile/core/_constants'
import {useEffect, useState} from 'react'

import {useAuth} from '../../auth'
import {
  companyData,
  getBccTrackingData,
  getUserList,
  getMailInfo,
  getPendingUsers,
  connectNylas,
  activeNylas,
} from '../../profile/core/_requests'
import {toast} from 'react-toastify'
import {CountryModel} from '../../onboarding'
import {getCountry, state} from '../../onboarding/core/_requests'
import {roleValues} from '../../../core/_constants'
// import NoDataPage from '../../widgets/components/NoDataPage'
import '../../../../app/modules/widgets/components/styles/rectangularTabs.scss'
import {useThemeMode} from '../../../../_metronic/partials'
import {Toolbar} from '../../../../_metronic/layout/components/toolbar/Toolbar'
// import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import TeamCalendar from '../../profile/components/TeamCalendar'
import TeamContacts from '../../profile/components/TeamContacts'
// import {useModuleStatus} from '../../../hooks/useModuleStatus'
import {OtherCompanySettings} from '../../profile/components/OtherCompanySettings'
import brandingConfig from '../../../../config/brandingConfig'
import useGetBillingData from '../../../hooks/useGetBillingData'
import AIMemory from '../../recordskeeper-ai/components/SettingsAndPolicies/AIMemory'
// import { Team } from '../../profile/components/Team'
import {InfoCard2} from '../../widgets/components/UI/InfoCard2'
import TeamUpdated from '../../profile/components/TeamUpdated'
// import { PaymentDue } from '../../dashboard/components/PaymentDue'

const CompanySettings = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const tabParam = params.get('tab')
    const tabIndex = options.findIndex((opt) => opt.title.toLowerCase() === tabParam?.toLowerCase())
    if (tabIndex !== -1) {
      setTab(tabIndex + 1)
    } else {
      setTab(1) // Default to the first tab
      navigate(`${location.pathname}?tab=${options[0].title.toLowerCase()}`)
    }
    getCompanyData()
  }, [location.search]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleTabChange = (index: number) => {
    setTab(index + 1)
    navigate(`${location.pathname}?tab=${options[index].title.toLowerCase()}`)
  }
  const {formatMessage} = useIntl()
  const [key] = useState(1)
  const {mode} = useThemeMode()
  const [showDemoDashboard, setshowDemoDashboard] = useState(false)
  // const [companyTags, setCompanyTags] = useState([])

  const {companyId, billingData, setShowBillingModal, role, companyQueuePosition} = useAuth() //eslint-disable-line

  const [companyImgName, setCompanyImgName] = useState<string>()
  const [companyLogoName, setCompanyLogoName] = useState<string>()
  const [companyIconName, setCompanyIconName] = useState<string>()
  const [companyLightLogoName, setCompanyLightLogoName] = useState<string>()
  const [companyDarkLogoName, setCompanyDarkLogoName] = useState<string>()
  const {getBillingDetailsAPI} = useGetBillingData(companyId!)
  const [getCompanyApiLoading, setGetCompanyApiLoading] = useState(false)
  const [countryId, setCountryId] = useState<string | undefined>()
  const [countryOptions, setcountryOptions] = useState<any[]>([])
  const [stateOptions, setstateOptions] = useState<any[]>([])

  // const {moduleStatus} = useModuleStatus()
  // const sidebarOptions = ['Email', 'Calendar', 'APIs']
  // const sidebarOptions = [
  //   'Promotional Emails',
  //   'Transactional Emails',
  //   'Team Calendar',
  //   'Team Contacts',
  // ]
  // !moduleStatus && sidebarOptions.splice(1, 1)
  // const [sidebar, setSidebar] = useState(1)
  // const emailOptions = ['Promotional Email', 'Transactional Email']
  // const [subbar, setSubbar] = useState(1)

  const [bccEmail, setBccEmail] = useState('')
  const [emailSignature, setEmailSignature] = useState('')
  const [nylasEmailSignature, setNylasEmailSignature] = useState('')

  const [userList, setUserList] = useState<any[]>([]) //eslint-disable-line
  const [pendingUsersList, setPendingUsersList] = useState<any[]>([]) //eslint-disable-line

  const [postmarkRadio, setPostmarkRadio] = useState(false)
  const [sendgridRadio, setSendgridRadio] = useState(false)
  const [foundercrateRadio, setFoundercrate] = useState(false)
  const [customsmtpRadio, setCustomSmtpRadio] = useState(false)

  const [nylasGoogleRadio, setNylasGoogleRadio] = useState(false)
  const [nylasMicrosoftRadio, setNylasMicrosoftRadio] = useState(false)
  const [tab, setTab] = useState(1)

  const [searchParams, setSearchParams] = useSearchParams()
  const [connectedAccount, setconnectedAccount] = useState('')
  const [selectedHashtags, setSelectedHastags] = useState<object[]>([])
  const [primaryColor, setPrimaryColor] = useState('#1f36d6')
  const [accentColor, setAccentColor] = useState('#AF5612')
  // api calling starts
  //Billing API Call

  const transformHashtags = (hashtags: any) => {
    return hashtags.map((tag: any) => ({
      label: tag.tagName,
      value: tag.tagName,
    }))
  }
  const getCompanyData = async () => {
    if (!companyId) return
    try {
      setGetCompanyApiLoading(true)
      if (companyId) {
        const {
          data: {success, data, errors},
        } = await companyData(companyId)
        if (success) {
          setGetCompanyApiLoading(false)
          setCompanyLogoName(data?.featuredImage?.name)
          setCompanyImgName(data?.file?.name)
          setCompanyDarkLogoName(data?.brandDarkImage?.name)
          setCompanyLightLogoName(data?.brandLightImage?.name)
          setshowDemoDashboard(data.showDemoDashboard === 1 ? true : false)
          setSelectedHastags(transformHashtags(data.tags))
          setPrimaryColor(data?.brandPrimaryColor || '#1f36dh')
          setAccentColor(data?.brandAccentColor || '#AF56112')
          companyInitialValues.companyName = data.name || ''
          companyInitialValues.tagline = data.tagline || ''
          companyInitialValues.teamSize = data.teamSize || ''
          companyInitialValues.legalName = data.legalName || ''
          companyInitialValues.operatingStatus = data.operatingStatus || ''
          companyInitialValues.currencyId = data.currencyId || 0
          companyInitialValues.shortDescription = data.shortDescription || ''
          companyInitialValues.description = data.description || ''
          companyInitialValues.foundedDate = data.foundedDate || ''
          companyInitialValues.problemStatement = data.problemStatement || ''
          companyInitialValues.USP = data.USP
          companyInitialValues.industry = data.industry || ''
          companyInitialValues.country = data.countryId || 0
          companyInitialValues.state = data.stateId || 0
          companyInitialValues.city = data.city || ''
          companyInitialValues.zipCode = data.zipCode || 0
          companyInitialValues.founders = data.founders || ''
          companyInitialValues.logoId = data.logoId || ''
          companyInitialValues.socialMedia.website = data.website || ''
          companyInitialValues.socialMedia.facebook = data.facebook || ''
          companyInitialValues.socialMedia.twitter = data.twitter || ''
          companyInitialValues.socialMedia.linkedin = data.linkedin || ''
          companyInitialValues.socialMedia.instagram = data.instagram || ''
          companyInitialValues.socialMedia.webApp = data.webApp || ''
          companyInitialValues.socialMedia.iosApp = data.iosApp || ''
          companyInitialValues.socialMedia.androidApp = data.androidApp || ''
          companyInitialValues.socialMedia.youtube = data.youtube || ''
          companyInitialValues.socialMedia.reddit = data.reddit || ''
          companyInitialValues.socialMedia.tiktok = data.tiktok || ''
          companyInitialValues.socialMedia.whatsapp = data.whatsapp || ''
          companyInitialValues.socialMedia.telegram = data.telegram || ''
          companyInitialValues.socialMedia.snapchat = data.snapchat || ''
          companyInitialValues.socialMedia.weChat = data.weChat || ''
          companyInitialValues.socialMedia.pinterest = data.pinterest || ''
          companyInitialValues.socialMedia.discord = data.discord || ''
          companyInitialValues.socialMedia.twitch = data.twitch || ''
        } else {
          setGetCompanyApiLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    // if (companyId && (role === roleValues.OWNER || role === roleValues.ADMIN)) {

    if (companyId && role === roleValues.OWNER) {
      getCompanyData()
    }
  }, [companyId, role]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const fetchCountry = async () => {
      const {
        data: {data: countries},
      } = await getCountry()
      const countriesData = countries.map((country: CountryModel) => {
        return {
          id: country.countryId,
          name: country.country_name,
          value: country.countryId,
        }
      })
      setcountryOptions([...countriesData])
    }
    fetchCountry()
  }, [])

  useEffect(() => {
    const fetchState = async () => {
      try {
        if (!countryId) {
          return
        }
        const {
          data: {data: states, success},
        } = await state(countryId!)
        if (success) {
          const stateData = states.map((state: any) => {
            return {
              id: state.stateId,
              name: state.state_name,
              value: state.stateId,
            }
          })
          setstateOptions([...stateData])
        }
      } catch (err) {
        console.log(err)
      }
    }
    fetchState()
  }, [countryId]) // eslint-disable-line react-hooks/exhaustive-deps

  //for bcctracking
  useEffect(() => {
    const getBcctrackingData = async () => {
      try {
        if (companyId) {
          const {
            data: {success, data, errors},
          } = await getBccTrackingData(companyId)
          if (success) {
            setBccEmail(data.email)
          } else {
            errors.forEach((error: string) => {
              toast.error(formatMessage({id: error}))
            })
          }
        }
      } catch (err) {
        console.log(err)
      }
    }
    getBcctrackingData()
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const connectToNylas = async (provider: string) => {
      if (searchParams.has('code')) {
        const code = searchParams.get('code')

        try {
          const {
            data: {data, success, errors}, // eslint-disable-line
          } = await connectNylas(code, companyId, provider)
          if (success) {
            toast.success(formatMessage({id: 'Mailer updated successfully'}), {
              autoClose: 2000, // Toast will close after 2 seconds
              onClose: () => {
                searchParams.delete('code')
                setSearchParams(searchParams, {replace: true})
                document.location.reload() // Reload the page when the toast closes
              },
            })
            const isNylasActive = provider === 'google' ? 'nylasGoogle' : 'nylasMicrosoft'
            const {
              data: {data: activeData, success: activeSuccess, errors: activeError}, // eslint-disable-line
            } = await activeNylas(isNylasActive, companyId)

            if (!activeSuccess) {
              toast.error(formatMessage({id: 'Nylas is not active'}))
            } else {
              console.log('nylas data check', activeData)
              setconnectedAccount(provider)
            }
          } else {
            searchParams.delete('code')
            setSearchParams(searchParams, {replace: true})
            errors.forEach((error: string) => {
              toast.error(formatMessage({id: error}))
            })
          }
        } catch (err) {
          console.log(err)
          toast.error(formatMessage({id: 'There was an error! Please try again.'}))
        }
      } else if (searchParams.has('error')) {
        toast.error(
          searchParams.get('error_description') ||
            formatMessage({id: 'There was an error! Please try again.'})
        )
      }
    }

    const provider = localStorage.getItem('NYLAS_PROVIDER')
    if (provider) {
      console.log('chekcing data', provider)
      connectToNylas(provider)
      localStorage.removeItem('NYLAS_PROVIDER')
    }
  }, [companyId, formatMessage, searchParams, setSearchParams])

  // Email Integration API
  const getMailInformation = async () => {
    try {
      const {
        data: {success, data, errors},
      } = await getMailInfo(companyId)
      if (success) {
        senderInitialValues.fromName = data.fromName
        senderInitialValues.fromEmail = data.fromAddress
        senderInitialValues.replyToName = data.replyToName
        senderInitialValues.replyToEmail = data.replyToAddress
        senderInitialValues.nylasFromName = data.nylasFromName
        senderInitialValues.nylasFromEmail = data.nylasFromAddress
        senderInitialValues.nylasReplyToName = data.nylasReplyToName
        senderInitialValues.nylasReplyToEmail = data.nylasReplyToAddress
        setEmailSignature(data.emailSignature)
        setNylasEmailSignature(data.nylasEmailSignature)
        if (data.sendgrid !== null) {
          initialValues.apiKey = data.sendgrid.apiKey
        }
        if (data.smtp !== null) {
          customSmtpInitialValues.username = data.smtp.username
          customSmtpInitialValues.encryption = data.smtp.encryption
          customSmtpInitialValues.password = data.smtp.password
          customSmtpInitialValues.server = data.smtp.server
          customSmtpInitialValues.port = data.smtp.port
        }
        if (data.postmark !== null) {
          postmarkInitialValues.serverToken = data.postmark.serverToken
        }
        if (data.isActive === 'postmark') {
          setPostmarkRadio(true)
          setSendgridRadio(false)
          setCustomSmtpRadio(false)
          setFoundercrate(false)
        } else if (data.isActive === 'sendgrid') {
          setPostmarkRadio(false)
          setSendgridRadio(true)
          setCustomSmtpRadio(false)
          setFoundercrate(false)
        } else if (data.isActive === 'foundercrate') {
          setPostmarkRadio(false)
          setSendgridRadio(false)
          setCustomSmtpRadio(false)
          setFoundercrate(true)
        } else if (data.isActive === 'smtp') {
          setPostmarkRadio(false)
          setSendgridRadio(false)
          setCustomSmtpRadio(true)
          setFoundercrate(false)
        }

        if (data.nylasGoogle !== null) {
          nylasGoogleInitialValues.grantId = data.nylasGoogle.grantId
        }

        if (data.nylasMicrosoft !== null) {
          nylasMicrosoftInitialValues.grantId = data.nylasMicrosoft.grantId
        }

        if (data.isNylasActive === 'nylasGoogle') {
          setconnectedAccount('google')
          setNylasGoogleRadio(true)
          setNylasMicrosoftRadio(false)
        } else if (data.isNylasActive === 'nylasMicrosoft') {
          setconnectedAccount('microsoft')
          setNylasGoogleRadio(false)
          setNylasMicrosoftRadio(true)
        }
      } else {
        console.log(errors)
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const getPendingUserList = async () => {
    if (companyId && role === roleValues.OWNER) {
      try {
        const {
          data: {success, data, errors},
        } = await getPendingUsers(companyId)
        if (success) {
          setPendingUsersList(Array.isArray(data) ? data : [])
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }

  const getUsersList = async () => {
    if (companyId && role === roleValues.OWNER) {
      try {
        const {
          data: {success, data, errors},
        } = await getUserList(companyId)
        if (success) {
          setUserList(data)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }

  useEffect(() => {
    if (companyId && role && role === roleValues.OWNER) {
      getUsersList()
      getPendingUserList()
    }
  }, [companyId, role]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (companyId) {
      getMailInformation()
    }
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (key === 6 && billingData?.subscription_items[0].item_price_id.split('-')[0] !== 'Gold') {
      setShowBillingModal(true)
    }
  }, [key, billingData]) // eslint-disable-line react-hooks/exhaustive-deps

  // api calling ends

  const options = [
    {title: formatMessage({id: 'General'}), subTitle: formatMessage({id: 'General Settings'})},
    {
      title: formatMessage({id: 'Integration'}),
      subTitle: formatMessage({id: 'Email & Other Integration'}),
    },
    {title: formatMessage({id: 'Teams'}), subTitle: formatMessage({id: 'Teams Settings'})},
    //    {title: formatMessage({id: 'Teams New'}), subTitle: formatMessage({id: 'Teams Settings'})},
    {title: formatMessage({id: 'AI Memory'}), subTitle: formatMessage({id: 'AI Memory Settings'})},
    {title: formatMessage({id: 'Bcc Tracking'}), subTitle: formatMessage({id: 'Bcc Tracking'})},
    {title: formatMessage({id: 'Other Settings'}), subTitle: formatMessage({id: 'Other Settings'})},
  ]

  const filteredOptions =
    brandingConfig.brandName === 'RecordsKeeper.AI'
      ? options.filter(
          (option) =>
            option.title !== formatMessage({id: 'Bcc Tracking'}) &&
            option.subTitle !== formatMessage({id: 'Bcc Tracking'})
        )
      : options

  const initialSidebarOptions = [
    {tabTitle: formatMessage({id: 'Promotional Emails'}), id: 1},
    {tabTitle: formatMessage({id: 'Transactional Emails'}), id: 2},
    {tabTitle: formatMessage({id: 'Team Calendar'}), id: 3},
    {tabTitle: formatMessage({id: 'Team Contacts'}), id: 4},
  ]

  const filteredInitialSidebarOptions =
    brandingConfig.brandName === 'RecordsKeeper.AI'
      ? initialSidebarOptions.filter(
          (option) => option.tabTitle !== formatMessage({id: 'Promotional Emails'})
        )
      : initialSidebarOptions

  // Filter sidebar options based on module status
  const filteredSidebarOptions = filteredInitialSidebarOptions.filter((option) => ![1, 3, 4].includes(option.id))
  const [selectedSidebarId, setSelectedSidebarId] = useState(filteredSidebarOptions[0]?.id);

  return (
    <>
      <div className='px-6 d-md-flex flex-md-column align-items-start row'>
        <div className='d-md-flex d-flex justify-content-md-between w-100 pt-1 mb-4 col-12'>
          <div className='page-title d-flex flex-column justify-content-center flex-wrap me-3'>
            <h1 className='page-heading d-flex text-dark fw-bold fs-4 flex-column justify-content-center'>
              {formatMessage({id: 'Company Settings'})}
            </h1>
            <ul className='breadcrumb breadcrumb-separatorless fw-semibold font-size-12 my-2'>
              <li className='breadcrumb-item text-muted'>
                <a href='/' className='text-primary'>
                  {formatMessage({id: 'Home'})}
                </a>
              </li>
              <li className='breadcrumb-item'>
                <span className='h-1px bullet'></span>
              </li>
              <li className='breadcrumb-item text-muted text-dark'>
                {formatMessage({id: 'Company Settings'})}
              </li>
            </ul>
          </div>
          <Toolbar />
        </div>

        <div
          className='p-0'
          style={{
            overflowX: 'auto',
            whiteSpace: 'nowrap',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          <div
            className='d-flex gap-3 px-md-3 col-md-8 col-12'
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {filteredOptions.map((opt, index) => (
              <div
                key={index}
                className={
                  `col options-container p-4 align-content-center cursor-pointer  border border-muted` +
                  (tab === index + 1 ? ' selected-option  border-primary' : '')
                }
                style={{minWidth: '200px', flex: '0 0 auto'}}
                onClick={() => {
                  handleTabChange(index)
                  // if (
                  //   index + 1 === 4 &&
                  //   billingData?.subscription_items[0].item_price_id.split('-')[0] !== 'Gold'
                  // ) {
                  //   setShowBillingModal(true)
                  // }
                }}
              >
                <div className='d-flex align-items-center gap-1'>
                  {/* {index + 1 === 4 && (
                  <img
                    src={toAbsoluteUrl(LockIcon)}
                    alt='lock icon'
                    width={18}
                    className={`${
                      billingData?.subscription_items[0].item_price_id.split('-')[0] !== 'Gold'
                        ? ''
                        : 'd-none'
                    }`}
                    height={18}
                  />
                )} */}
                  <h1 className='m-0'>{formatMessage({id: opt.title})}</h1>
                </div>
                <p className='mt-2'>{formatMessage({id: opt.subTitle})}</p>
              </div>
            ))}
          </div>
        </div>

        <div className='mt-5 mb-9 w-100  px-0 px-md-3'>
          {tab === 1 && (
            <Company
              key={key}
              getCompanyApiLoading={getCompanyApiLoading}
              setCompanyImgName={setCompanyImgName}
              companyLogoName={companyLogoName}
              setCompanyLogoName={setCompanyLogoName}
              companyImgName={companyImgName}
              setCountryId={setCountryId}
              countryOptions={countryOptions}
              stateOptions={stateOptions}
              companyIconName={companyIconName}
              setCompanyIconName={setCompanyIconName}
              companyLightLogoName={companyLightLogoName}
              setCompanyLightLogoName={setCompanyLightLogoName}
              companyDarkLogoName={companyDarkLogoName}
              setCompanyDarkLogoName={setCompanyDarkLogoName}
              selectedHashtags={selectedHashtags}
              setSelectedHastags={setSelectedHastags}
              primaryColor={primaryColor}
              accentColor={accentColor}
              setPrimaryColor={setPrimaryColor}
              setAccentColor={setAccentColor}
              getBillingDetails={getBillingDetailsAPI}
            />
          )}

          {tab === 2 && (
            <div className='d-flex flex-md-row flex-column'>
              <div
                className='mb-9 sidebar-investor-db col-md-1 d-none d-md-flex '
                style={{width: '14%'}}
              >
                {filteredSidebarOptions.map((sideTab) => (
                  <ul className='text-muted text-active-primary d-md-flex flex-column d-none align-items-left p-0 m-0 cursor-pointer '>
                    <li
                      className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${
                        selectedSidebarId === sideTab.id
                          ? '  border-top-0 border border-bottom-0 border-right-0 border-left-3 border-primary text-primary border-5'
                          : ''
                      }`}
                      onClick={() => setSelectedSidebarId(sideTab.id)}
                    >
                      {formatMessage({id: sideTab.tabTitle})}
                    </li>
                  </ul>
                ))}
              </div>

              <div
                className='mb-2 sidebar-investor-db col-md-1 d-flex d-md-none'
                style={{width: '100%'}}
              >
                <div
                  className='d-md-none d-flex'
                  style={{
                    display: 'flex',
                    overflowX: 'scroll',
                    whiteSpace: 'nowrap',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                  }}
                >
                  {filteredSidebarOptions.map((sideTab) => (
                    <ul
                      key={sideTab.id}
                      className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 flex-nowrap mobile-tab-both my-md-0 mb-2 d-md-none'
                      style={{display: 'flex', flexWrap: 'nowrap'}}
                    >
                      <li
                        className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${
                          selectedSidebarId === sideTab.id
                            ? 'border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                            : ''
                        }`}
                        onClick={() => setSelectedSidebarId(sideTab.id)}
                      >
                        {formatMessage({id: sideTab.tabTitle})}
                      </li>
                    </ul>
                  ))}
                </div>
              </div>

              <div
                className={`d-flex mb-9 px-7 rounded-2 w-100 ${mode !== 'dark' ? 'bg-white' : ''}`}
                style={{background: '#1e1e2d'}}
              >
                {selectedSidebarId === 1 && (
                  <div className='d-flex mt-3 flex-column w-100'>
                    <div className='w-100'>
                      <EmailIntegration
                        key={1}
                        companyId={companyId}
                        getMailInformation={getMailInformation}
                        customsmtpRadio={customsmtpRadio}
                        foundercrateRadio={foundercrateRadio}
                        sendgridRadio={sendgridRadio}
                        postmarkRadio={postmarkRadio}
                        emailSignature={emailSignature}
                      />
                    </div>
                  </div>
                )}
                {selectedSidebarId === 2 && (
                  <div className='mt-3 w-100'>
                    <div className='w-100'>
                      <TransactionalEmailIntegration
                        key={2}
                        companyId={companyId}
                        getMailInformation={getMailInformation}
                        nylasGoogleRadio={nylasGoogleRadio}
                        nylasMicrosoftRadio={nylasMicrosoftRadio}
                        nylasEmailSignature={nylasEmailSignature}
                        connectedAccount={connectedAccount}
                        setconnectedAccount={setconnectedAccount}
                      />
                    </div>
                  </div>
                )}
                {selectedSidebarId === 3 && (
                  <div className='mt-3 w-100'>
                    {/* <div className='d-flex'> */}
                    <div className='w-100'>
                      {/* <NoDataPage width={`0`} commingSoon /> */}
                      <TeamCalendar
                        key={3}
                        companyId={companyId}
                        getMailInformation={getMailInformation}
                        nylasGoogleRadio={nylasGoogleRadio}
                        nylasMicrosoftRadio={nylasMicrosoftRadio}
                        nylasEmailSignature={nylasEmailSignature}
                        connectedAccount={connectedAccount}
                        setconnectedAccount={setconnectedAccount}
                      />
                    </div>
                  </div>
                )}
                {selectedSidebarId === 4 && (
                  <div className='mt-3 w-100'>
                    {/* <div className='d-flex'> */}
                    <div className='w-100'>
                      {/* <NoDataPage width={`0`} commingSoon /> */}
                      <TeamContacts
                        key={3}
                        companyId={companyId}
                        getMailInformation={getMailInformation}
                        nylasGoogleRadio={nylasGoogleRadio}
                        nylasMicrosoftRadio={nylasMicrosoftRadio}
                        nylasEmailSignature={nylasEmailSignature}
                        connectedAccount={connectedAccount}
                        setconnectedAccount={setconnectedAccount}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* {tab === 3 && (
            <Team
              key={key}
              userList={userList}
              pendingUserList={pendingUsersList}
              getUserList={getUsersList}
              getPendingUsers={getPendingUserList}
            />
          )} */}

          {tab === 3 && <TeamUpdated />}
          {tab === 4 && (
            <>
              <InfoCard2
                title={'Configuring AI Memory for Entire Company to Chat Smarter'}
                desc={
                  'Create Organization or Company-Level Memory Blocks to help RecordsKeeper.AI recall important context during web and mobile chats. These memory blocks enable the AI to remember relationships beyond file-level data, making conversations more natural. These memory blocks are shared with other users and are meaningful for your entire organization.'
                }
                desc2={`For example, if you ask, “Give me the most recent Invoice from our auditor” the AI understands who your auditor is without needing a name, thanks to stored contextual memory—enhancing accuracy and relevance in responses.`}
                slug={
                  'https://help.recordskeeper.ai/en/articles/10709233-guide-to-configuring-ai-memory-for-enterprise-wide-intelligent-conversations'
                }
              />
              <AIMemory aiMemoryFor={'company'} />
            </>
          )}

          {/* {tab === 4 &&
          (billingData?.subscription_items[0].item_price_id.split('-')[0] === 'Gold' ? (
            <BCCTracking key={key} bccEmail={bccEmail} />
          ) : (
            <></>
          ))} */}
          {/* {tab === 4 && <BCCTracking key={key} bccEmail={bccEmail} />} */}
          {tab === 5 && brandingConfig.brandName === 'RecordsKeeper.AI' ? (
            <OtherCompanySettings
              key={tab}
              getCompanyApiLoading={getCompanyApiLoading}
              showDemoDashboard={showDemoDashboard}
              setshowDemoDashboard={setshowDemoDashboard}
            />
          ) : tab === 6 ? (
            <BCCTracking key={key} bccEmail={bccEmail} />
          ) : null}

          {tab === 7 && (
            <>
              <OtherCompanySettings
                key={tab}
                getCompanyApiLoading={getCompanyApiLoading}
                showDemoDashboard={showDemoDashboard}
                setshowDemoDashboard={setshowDemoDashboard}
              />
            </>
          )}
        </div>
      </div>
    </>
  )
}
export {CompanySettings}
